import * as React from 'react';
import {Dialog, DialogOverlay, DialogContent} from '@reach/dialog';
import '@reach/dialog/styles.css';
import s from './TestModal.module.css';

export default function TestModal(props) {
  const {isOpen, closeModal, testName, startTest, description, instruction} = props;

  return (
    <DialogOverlay
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(200, 200, 200, 0.4)',
      }}
      isOpen={isOpen}
      onDismiss={closeModal}
    >
      <DialogContent
        style={{
          flexDirection: 'column',
          justifyContent: 'space-between',
          background: 'rgba(41, 41, 41)',
          padding: '0',
          height: 'auto',
          overflow: 'hidden',
          borderRadius: '25px',
          margin: '0',
          width: '50%',
        }}
      >
        <div className={s.Header}>
          <div className={s.TestTitle}>{testName}</div>
          <button className={s.CloseModalBtn} onClick={closeModal}>
            X
          </button>
        </div>
        <div className={s.ModalMsgWrapper}>
          <div className={s.Description}>Description: {description}</div>
          <div className={s.Instructions}>Instructions: {instruction}</div>
        </div>
        <div className={s.BtnOptionWrapper}>
          <button className={s.StartBtn} onClick={startTest}>
            Start
          </button>
        </div>
      </DialogContent>
    </DialogOverlay>
  );
}
